import React, { Fragment } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import cn from 'classnames';
import { ControlLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Media from 'react-media';
import Select from 'react-select';

import styles from './BusinessStartDateQuestion.module.css';
import NativeSelect from '../../../components/FormField/NativeSelect/NativeSelect';
import InputTooltip from '../../../components/InputTooltip/InputToolTip';
import PureInput from '../../../components/PureInput';
import { numbersOnly } from '../../../helpers/helpers';
import normalizer from '../../../helpers/inputNormalizer';
import months from '../../../helpers/months';
import * as breakpoints from '../../../matchMedia/breakpoints';
import messages from '../BusinessIntroduction.messages';

export const BusinessStartDateQuestion = ({ monthField, yearField }) => {
    const hasError =
        (monthField.touched && monthField.error) ||
        (yearField.touched && yearField.error);

    return (
        <div className={cn({ invalid: hasError })}>
            <ControlLabel>
                When did the business start
                <div className="tooltip-holder">
                    {' '}
                    trading?
                    <InputTooltip
                        overlayText={
                            <FormattedMessage
                                {...messages.startedTradingDateTooltip}
                            />
                        }
                        overlayPlacement={'top'}
                    />
                </div>
            </ControlLabel>
            {hasError && (
                <div className="multi-error-container">
                    <div className="error multi-error">{monthField.error}</div>
                    <div className="error multi-error">{yearField.error}</div>
                </div>
            )}
            <div className={styles.inputWrapper}>
                <div className={styles.monthWrapper}>
                    <MonthInput field={monthField} />
                </div>
                <div className={styles.yearWrapper}>
                    <YearInput field={yearField} />
                </div>
            </div>
            <div className="toggle-role">
                <span className={styles.infoText}>
                    New business? Enter the expected launch date
                </span>
            </div>
        </div>
    );
};

const MonthInput = ({ field }) => {
    const onChange = (item) => {
        const value = (item && item.value) || '';
        field.onChange(value);
    };

    return (
        <Fragment>
            <Media
                query={breakpoints.SCREEN_XS}
                render={() => (
                    <NativeSelect
                        className={styles.monthSelectMobile}
                        data-testid="month-input-select"
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'trading_from_month'
                            });
                        }}
                        onChange={(event) => {
                            onChange({ value: event.target.value });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'trading_from_month'
                                });
                            }
                        }}
                        value={field.value}>
                        {months.map(({ value, label }) => (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        ))}
                    </NativeSelect>
                )}
            />

            <Media
                query={breakpoints.NOT_XS}
                render={() => (
                    <div data-testid="month-input-react-select">
                        <Select
                            className="month-select"
                            data-testid="month-input-select"
                            placeholder="Month"
                            options={months}
                            onChange={(event) => {
                                if (event.value.length > 0) {
                                    tracking.ampli.formFieldCompleted({
                                        form_field: 'trading_from_month'
                                    });
                                }
                                onChange(event);
                            }}
                            onFocus={() => {
                                tracking.ampli.formFieldStarted({
                                    form_field: 'trading_from_month'
                                });
                            }}
                            value={field.value}
                            inputProps={{
                                name: 'company.registered.mm'
                            }}
                        />
                    </div>
                )}
            />
        </Fragment>
    );
};

const YearInput = ({ field }) => {
    const maskedYear = normalizer(field, numbersOnly, null);

    return (
        <PureInput
            whenBlur={(event) => {
                if (event.target.value.length > 0) {
                    tracking.ampli.formFieldCompleted({
                        form_field: 'trading_from_year'
                    });
                }
            }}
            whenFocus={() => {
                tracking.ampli.formFieldStarted({
                    form_field: 'trading_from_year'
                });
            }}
            test="Hello "
            type="text"
            placeholder="YYYY"
            maxLength="4"
            pattern="\d*"
            {...maskedYear}
        />
    );
};
